// @flow

import React, { Component } from "react";

import "./ResponsiveImage.scss";

export default class ResponsiveImage extends Component {
  constructor(props) {
    super(props);

    this.state = { currentSrc: "" };
  }
  onLoad = event => {
    this.setState({
      currentSrc: event.target.currentSrc
    });
  };
  render() {
    const placeholderSrc = (width, height) => `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}"%3E%3C/svg%3E`
    const { imageName, imageClass } = this.props;
    return (
      <img
        src={`/img/301/234/${imageName}`}
        srcSet={`${"/img/301/234/" + imageName} 300w, ${"/img/768/596/" +
          imageName} 768w`}
        onLoad={this.onLoad}
        className={"responsive-image " + imageClass}
        alt=""
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ResponsiveImage/ResponsiveImage.js